const STORAGE_KEY = 'sm_cal_flow';

export function hasCalParam(search) {
  if (!search) return false;
  return new URLSearchParams(search.startsWith('?') ? search : `?${search}`).has('cal');
}

export function persistCalFlow() {
  try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) { /* ignore */ }
}

export function clearCalFlow() {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* ignore */ }
}

export function isCalFlow(search) {
  if (hasCalParam(search)) {
    persistCalFlow();
    return true;
  }
  try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (_) { return false; }
}

export function loginPath(search) {
  return isCalFlow(search) ? '/login?cal' : '/login';
}

export function registerPath(search) {
  return isCalFlow(search) ? '/register?cal' : '/register';
}

export function onboardingPath(search) {
  return isCalFlow(search) ? '/onboarding?cal' : '/onboarding';
}
